class ErrorUsersController {
    static controller($scope) {
        'ngInject';


    }
}

export default ErrorUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/error.users.controller.js